import React from 'react';
import {
  AccessItemLeftContainer,
  AccessItemStyled,
  EditAccess,
  ReadAccess,
} from './AccessItem.Styles';

import { CasePermissionsType } from 'src/types';
import { StyledCheckbox } from '../../Steps/AccessStep.styles';

export enum AccessActionEnum {
  ADD = 'add',
  REMOVE = 'remove',
}
interface AccessItemProps {
  children: React.ReactNode;
  selectedPermissions: CasePermissionsType[];
  readPermission: CasePermissionsType;
  editPermission?: CasePermissionsType;
  PIIPermission?: CasePermissionsType;
  handleSetPermissions: (
    permissions: CasePermissionsType[],
    action: AccessActionEnum,
  ) => void;
  disabled?: boolean;
  readPermissionDisabled?: boolean;
}

export const AccessItem = ({
  children,
  selectedPermissions,
  readPermission,
  editPermission,
  PIIPermission,
  handleSetPermissions,
  disabled,
  readPermissionDisabled,
}: AccessItemProps) => {
  const hasReadPermission = selectedPermissions.includes(readPermission);
  const hasEditPermission = editPermission
    ? selectedPermissions.includes(editPermission)
    : false;

  const handleChangeReadPermissions = () => {
    const permissionsToRemove = PIIPermission
      ? [readPermission, PIIPermission]
      : [readPermission];

    if (hasReadPermission) {
      handleSetPermissions(permissionsToRemove, AccessActionEnum.REMOVE);
    } else {
      handleSetPermissions([readPermission], AccessActionEnum.ADD);

      if (editPermission) {
        handleSetPermissions([editPermission], AccessActionEnum.REMOVE);
      }
    }
  };

  const handleChangeEditPermisions = () => {
    if (editPermission) {
      const permissionsToRemove = PIIPermission
        ? [editPermission, PIIPermission]
        : [editPermission];

      if (hasEditPermission) {
        handleSetPermissions(permissionsToRemove, AccessActionEnum.REMOVE);
      } else {
        handleSetPermissions([editPermission], AccessActionEnum.ADD);
        handleSetPermissions([readPermission], AccessActionEnum.REMOVE);
      }
    }
  };

  return (
    <AccessItemStyled>
      <div>{children}</div>
      <AccessItemLeftContainer>
        <ReadAccess>
          <StyledCheckbox
            checked={hasReadPermission}
            onChange={handleChangeReadPermissions}
            disabled={disabled || readPermissionDisabled}
            data-testid={`${readPermission}`}
          />
        </ReadAccess>

        <EditAccess>
          {editPermission && (
            <StyledCheckbox
              checked={hasEditPermission}
              onChange={handleChangeEditPermisions}
              disabled={disabled}
              data-testid={`${editPermission}`}
            />
          )}
        </EditAccess>
      </AccessItemLeftContainer>
    </AccessItemStyled>
  );
};
